var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77344 18.5547C9.54427 18.5547 9.34375 18.4453 9.17188 18.2266L5.16406 13.2891C5.10677 13.2161 5.0625 13.1458 5.03125 13.0781C5.00521 13.0052 4.99219 12.9323 4.99219 12.8594C4.99219 12.7031 5.04427 12.5729 5.14844 12.4688C5.25781 12.3594 5.39323 12.3047 5.55469 12.3047C5.7474 12.3047 5.91667 12.401 6.0625 12.5938L9.75 17.1953L17.0234 5.74219C17.0911 5.63802 17.1615 5.5651 17.2344 5.52344C17.3073 5.47656 17.4036 5.45312 17.5234 5.45312C17.6797 5.45312 17.8073 5.5026 17.9062 5.60156C18.0052 5.70052 18.0547 5.83073 18.0547 5.99219C18.0547 6.05469 18.0443 6.11979 18.0234 6.1875C18.0026 6.25521 17.9661 6.33073 17.9141 6.41406L10.3516 18.2344C10.2057 18.4479 10.013 18.5547 9.77344 18.5547Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.fa845ee9.svg";
export { ForwardRef as ReactComponent };